/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { DeviceModel } from '../../../core/device';
import { BrandingUiInfoKeys } from '../../../core/entities/BrandingUiInfoKeys';
import { DefaultServicesClientImpl } from '../../../core/impls';
import { Locale } from '../../../core/locale/Locale';
import { LocaleKeys } from '../../../core/locale/LocaleKeys';
import { Log, QoEAppLogger, RestartReasonsOperationsLogger, VuLogger } from '../../../core/logging';
import { ScreenTaskControllerTypes } from '../../../core/navigation/ScreenTaskControllerTypes';
import { VideoPlaybackController } from '../../../core/videoplayer/VideoPlaybackController';
import { hideOverlayDialog, showOverlayDialog } from '../../overlaydialog/overlaydialog.reducers';
import { IOverlayDialog } from '../../overlaydialog/overlaydialogprops';
import { setScreenTaskController } from '../../screens/screens.reducers';
import { OverlayTypes } from '../OverlayTypes';

const GLOBAL_MOUSE_TRAP: string = 'HideExitConfirmationOverlay';
const TAG: string = 'ExitConfirmationOverlay';

export const onKeyBackExitConfirmationOverlay = () => (dispatch: Function) => {
    VuLogger.logExitConfirmationOverlayCancelUserAction();
    dispatch(hideOverlayDialog());
};

export const onKeyOkExitConfirmationOverlay = () => (dispatch: Function, getState: Function) => {
    const { verticalPosition: overlayHighlightVerticalPosition } = getState().overlayHighlight;
    const playerInstance = VideoPlaybackController.getInstance();
    if (overlayHighlightVerticalPosition === 0) {
        QoEAppLogger.logAppExit(
            playerInstance.getPlayerStats(),
            playerInstance.getPlayerCurrentTime(),
            playerInstance.getSeekRange(),
        );

        RestartReasonsOperationsLogger.getInstance().updateAppState(
            RestartReasonsOperationsLogger.AppState.NORMAL_USER_EXIT,
        );
        VuLogger.logExitConfirmationOverlayOkUserAction();
        VuLogger.logAppExitEvent(VuLogger.AppExitActions.EXIT);
        Log.i(TAG, 'OK has been pressed');
        DeviceModel.closeApplication();
    } else {
        VuLogger.logExitConfirmationOverlayCancelUserAction();
        dispatch(hideOverlayDialog());
    }
};

export const onMouseClickExitConfirmationOverlay =
    () => (dispatch: Function, getState: Function) => {
        const { value } = getState().inputFactory;

        if (value === GLOBAL_MOUSE_TRAP) {
            dispatch(hideOverlayDialog());
            return;
        }
        dispatch(onKeyOkExitConfirmationOverlay());
    };

export const showExitConfirmationOverlayDialog = () => (dispatch: Function) => {
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.EXIT_CONFIRMATION_OVERLAY));
    const displayName = new DefaultServicesClientImpl().getBrandingUiInfoForKey(
        BrandingUiInfoKeys.DISPLAY_NAME,
    );
    const overlayDialogProps: IOverlayDialog = {
        description: Locale.getString(
            LocaleKeys.GUIDE_EXIT_CONFIRMATION_OVERLAY_DESCRIPTION,
        ).replace('DISPLAY_NAME', displayName),
        hasDimmer: true,
        hasSeperator: false,
        mouseTrapValue: GLOBAL_MOUSE_TRAP,
        options: [
            { text: Locale.getString(LocaleKeys.OVERLAY_OPTION_OK_TEXT) },
            {
                text: Locale.getString(LocaleKeys.OVERLAY_OPTION_CANCEL_TEXT),
            },
        ],
        overlayType: OverlayTypes.EXIT_CONFIRMATION,
        title: Locale.getString(LocaleKeys.GUIDE_EXIT_CONFIRMATION_OVERLAY_TITLE),
    };
    dispatch(showOverlayDialog(overlayDialogProps));
};
